import { forwardRef } from 'react'
import './IconButton.css'

export const IconButton = forwardRef(function IconButton(
  { size = 'md', plain = false, label, children, onClick, style, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={
        'u-iconbtn' +
        (size === 'sm' ? ' u-iconbtn--sm' : '') +
        (plain ? ' u-iconbtn--plain' : '')
      }
      aria-label={label}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children}
    </button>
  )
})

export default IconButton
